import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import ProtectedAdminRoute from "@/components/ProtectedRoutes/ProtectedAdminRoute";

const AllEvents = lazy(() => import("@/pages/agent/events/calendar/AllEvents"));
const Conferences = lazy(() => import("@/pages/agent/events/conferences/Conferences"));
const ConferencesArchives = lazy(
  () => import("@/pages/agent/events/conferences/components/ConferenceArchives/ConferenceArchives"),
);
const Roadshows = lazy(() => import("@/pages/agent/events/roadshows/RoadshowsPage"));
const RoadshowsRegistration = lazy(() => import("@/pages/agent/events/roadshows-registration/RoadshowsRegistration"));
const Recordings = lazy(() => import("@/pages/agent/events/recordings/Recordings/Recordings"));
const RecordingDetail = lazy(() => import("@/pages/agent/events/recordings/RecordingDetail/RecordingDetail"));
const FitTrip = lazy(() => import("@/pages/agent/events/fit-trip/FitTrip"));

const Error404 = lazy(() => import("@/pages/Error404"));

const eventsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "calendar",
    element: <AllEvents />,
  },
  {
    path: "roadshows",
    element: <Roadshows />,
  },
  {
    path: "roadshow-registration",
    element: <RoadshowsRegistration />,
  },
  {
    path: "conferences",
    children: [
      {
        index: true,
        element: <Conferences />,
      },
    ],
  },
  {
    path: "recordings",
    children: [
      {
        index: true,
        element: <Recordings />,
      },
      {
        path: ":id",
        element: <RecordingDetail />,
      },
    ],
  },
  // {
  //   path: "fit-trip",
  //   element: <FitTrip />,
  // },
];

export default eventsRoutes;
